import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    extraData: null
  },
  mutations: {
    setExtraData(state, data) {
      state.extraData = data
    }
  }
})